<template>
  <form @submit.prevent="onSubmit" class="row g-3">

    <div class="col-12" v-if="showEmail">
      <label for="email" class="form-label">Email</label>
      <div class="input-group has-validation">
        <input type="text" name="email" v-model="email" class="form-control" id="email" required>
      </div>
    </div>

    <div class="col-12">
      <label for="code" class="form-label">Код</label>
      <input v-model="code" type="text" name="code" class="form-control" id="code" required>
      <div class="invalid-feedback">Please enter your password!</div>
    </div>

    <div v-if="error" class="invalid-feedback" style="display: block" v-html="error"></div>
    <div class="col-12">
      <button class="btn btn-primary w-100" :disabled="loading" type="submit">
        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Подтвердить
      </button>
      <br>
      <button class="btn w-100" @click="onResend" :disabled="resendLoading">
        <span v-if="resendLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Отправить еще раз
      </button>
    </div>
    <div class="col-12">
      <p v-if="error" class="small mb-0 text-danger">{{ error }}</p>
      <p v-if="resendMessage" class="small mb-0" :class="resendError ? 'text-danger' : 'text-muted'">
        {{ resendMessage }}
      </p>
    </div>

    <div v-if="success" class="col-12">
      <p class="small mb-0 text-success">
        Email подтверждён. Теперь вы можете <router-link to="/login">войти</router-link>.
      </p>
    </div>
  </form>
</template>

<script setup>
import {nextTick, ref, watch} from 'vue';
import { useRoute } from 'vue-router';
import { usePersonal } from '@/features/personal/composables/usePersonal';

const route = useRoute();

const props = defineProps({
  email: String,
  showEmail: {type: Boolean, default: true}
});

const { confirmEmail, resendCode } = usePersonal();
const email = ref(props.email ?? route.query.email ?? '');
const code = ref('');
const error = ref('');
const success = ref(false);
const loading = ref(false);
const showEmail = ref(props.showEmail ?? true);

const resendLoading = ref(false);
const resendMessage = ref('');
const resendError = ref(false);

const emit = defineEmits(['onSuccess']);

async function onSubmit() {
  error.value = '';
  success.value = false;
  loading.value = true;
  resendLoading.value = false;

  try {
    await confirmEmail(email.value, code.value);
    success.value = true;
    emit('onSuccess');
  } catch (e) {
    error.value = e.response?.data?.message || 'Ошибка подтверждения';
  } finally {
    loading.value = false;
  }
}

async function onResend() {
  resendMessage.value = '';
  resendError.value = false;
  resendLoading.value = true;

  try {
    await resendCode(email.value);
    resendMessage.value = 'Код повторно отправлен на указанный email.';
  } catch (e) {
    resendMessage.value = e.response?.data?.message || 'Не удалось отправить код';
    resendError.value = true;
  } finally {
    resendLoading.value = false;
  }
}
</script>
